import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/learn/where-can-i-get-saint-tms")({
  beforeLoad: () => {
    throw redirect({
      to: "/learn/$slug",
      params: { slug: "saint-tms-locations" },
      replace: true,
    });
  },
});
